import React from 'react'
import type { LayoutProps } from 'antd'
import { Layout } from 'antd'
import SiderMenu from './sider'
import HeaderMenu from './header'
import FooterMenu from './footer'

const { Content } = Layout

export const Layouts = ({ children }: LayoutProps): JSX.Element => {
  return (
    <>
      <Layout className="min-h-screen">
        <HeaderMenu title={'SAGAアリーナ 見積サイト'} />
        <SiderMenu />
        <Layout>
          <Content className="layout">
            <div className="layout-inner">{children}</div>
          </Content>
        </Layout>
      </Layout>

      <FooterMenu />
    </>
  )
}

export default Layouts
